import { render, staticRenderFns } from "./CambiarEmail.vue?vue&type=template&id=51fda532&scoped=true&"
import script from "./CambiarEmail.vue?vue&type=script&lang=js&"
export * from "./CambiarEmail.vue?vue&type=script&lang=js&"
import style0 from "./CambiarEmail.vue?vue&type=style&index=0&id=51fda532&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51fda532",
  null
  
)

export default component.exports